import { MutationTree } from 'vuex'
import { IProductsState, IPlan, IProduct, IBundleProduct } from '@/@types'

const mutations: MutationTree<IProductsState> = {
  PASS_TYPES_UPDATED: (state, passTypes: Array<object>) => {
    state.passTypes = passTypes
  },
  AVAILABLE_PLANS_UPDATED: (state, plans: Array<IPlan>) => {
    state.availablePlans = plans
  },
  AVAILABLE_CERTIFICATIONS_UPDATED: (state, certifications: Array<IProduct>) => {
    state.availableCertifications = certifications
  },
  AVAILABLE_LIVE_VIRTUAL_TRAININGS_UPDATED: (state, liveVirtualTrainings: Array<IProduct>) => {
    state.availableLiveVirtualTrainings = liveVirtualTrainings
  },
  LIVE_VIRTUAL_TRAINING_DISCOUNT_UPDATED: (state, liveVirtualTrainingDiscount: number) => {
    state.liveVirtualTrainingDiscount = liveVirtualTrainingDiscount
  },
  ONE_EXCLUSIVE_PLAN_UPDATED: (state, isOnePlanAvailable: Boolean) => {
    state.isOnePlanAvailable = isOnePlanAvailable
  },
  AVAILABLE_EXAM_EXTENSIONS_UPDATED: (state, extensions: Array<IProduct>) => {
    state.extensions = extensions
  },
  AVAILABLE_PRODUCT_BUNDLES_UPDATED: (state, availableProductBundles: Array<IBundleProduct>) => {
    state.availableProductBundles = availableProductBundles
  },
}

export default mutations
